import { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PalletRemovalSection from './components/PalletRemovalSection';
import ProductCatalog from './components/ProductCatalog';
import AboutSection from './components/AboutSection';
import QuotationCTA from './components/QuotationCTA';
import TestimonialSection from './components/TestimonialSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import SEOSchema from '../../components/SEOSchema';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEOSchema type="organization" />
      <SEOSchema type="localBusiness" />
      <SEOSchema type="faq" />
      <Navigation isScrolled={isScrolled} />
      <main>
        <HeroSection />
        <ServicesSection />
        <PalletRemovalSection />
        <ProductCatalog />
        <AboutSection />
        <QuotationCTA />
        <TestimonialSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}